// Community Rules Management APIs

/**
 * @function ApiClient#AddRules
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} rulesData
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddRules(cid, rulesData, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(rulesData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  return await this._post(`/community/${cid}/rules`, formData, options);
}

/**
 * @function ApiClient#UpdateRules
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} rulesData
 * @param {any} files
 * @param {any} options = {}
 */
export async function UpdateRules(cid, rulesData, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(rulesData));
  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }
  return await this._put(`/community/${cid}/rules`, formData, options);
}

/**
 * @function ApiClient#GetRulesList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.startDate
 * @param {any} params.endDate
 * @param {any} params.type
 * @param {any} params.search
 * @param {any} options = {}
 */
export async function GetRulesList(cid, { sortBy, sortDesc, page, itemsPerPage, startDate, endDate, type, search }, options = {}) {
  if (!startDate) startDate = "";
  if (!endDate) endDate = "";
  if (!type) type = "";
  if (!search) search = "";

  return await this._get(
    `/community/${cid}/rules_list?p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&st=${startDate}&et=${endDate}&t=${type}&ss=${search}`,
    options,
  );
}

/**
 * @function ApiClient#DeleteRules
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} nID
 * @param {any} options = {}
 */
export async function DeleteRules(cid, nID, options = {}) {
  return await this._delete(`/community/${cid}/rules/${nID}`, options);
}

// Rules Type Management APIs

/**
 * @function ApiClient#GetRulesTypeItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetRulesTypeItemList(cid, options = {}) {
  return await this._get(`/community/${cid}/rules_type_list`, options);
}

/**
 * @function ApiClient#AddRulesTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function AddRulesTypeItem(cid, itemName, options = {}) {
  return await this._post(`/community/${cid}/rules_type?t=${itemName}`, null, options);
}

/**
 * @function ApiClient#UpdateRulesTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateRulesTypeItem(cid, items, options = {}) {
  return await this._put(`/community/${cid}/rules_type`, items, options);
}

/**
 * @function ApiClient#DeleteRulesTypeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteRulesTypeItem(cid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/rules_type?t=${itemName}`, options);
}
